import React from "react";

/**
 * Renders the vertical hairlines that sit on the container edges
 * (x = 60 and x = 1380 on the 1440 Figma frame) and run the full height
 * of the block they are placed in.
 *
 * `extra` adds the two additional rules the Figma frame shows in the
 * "Introducing Renaflex" band at x = 940 and x = 1160.
 */
export default function GridLines({ tone = "dark", extra = false }) {
  return (
    <div className={`rf-gridlines rf-gridlines--${tone}`} aria-hidden="true">
      <div className="rf-gridlines__inner">
        {extra ? (
          <>
            <span className="rf-gridlines__v" style={{ left: "66.6667%" }} />
            <span className="rf-gridlines__v" style={{ left: "83.3333%" }} />
          </>
        ) : null}
      </div>
    </div>
  );
}
